import ASS from "./../services/aanwezigheden-secundair.service.js";
import RS from "@/services/rest.service.js";
import * as globalMutationTypes from "@/store/mutation-types.js";
import * as mutationTypes from "./mutation-types.js";
import _ from "lodash";
import router from "@/router";

let studentSecundairService = new ASS();
const restService = new RS();





export const getAccountInfo = function({ dispatch, state, commit }, params) {
   
    let verzoek = "/UserFiche" + "/Read/" 

  restService.GET(
    verzoek,
    // {'_dc=': new Date().getTime(), groepPar: state.selectedGroep.ID},
    {},
    function(res) {
      commit(mutationTypes.SET_ACCOUNT_INFO, res);
     
    },
    undefined,
    true,
    0,
    "Provider"
  );
};
export const changePassword = function({ dispatch, state, commit, rootState }, payload) {
  var zetParallelleRequest = {
    action: "WisaUserAPI",
    method: "ChangePassword",
    data: [],
    type: "rpc",
    tid: 2
  };

  
  zetParallelleRequest.data = payload;

  // Herwerken naar EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS
  return new Promise((resolve, reject) => {
  restService.POST(
    "RPC/Router",
    zetParallelleRequest,
    function(res) {
      if(res.data.error ===null || res.data.error ===undefined ){
        // $("#passwordChangedSuccesfully").modal("show")
      }
      if(res.data.error !==null && res.data.error !==undefined){
        commit(globalMutationTypes.SHOW_MESSAGE, ["Fout: " + res.data.error.message, "error"], {
          root: true
        });
      
        // $("#errorMessage").modal("show")
        // $('#errorMessage').on('show.bs.modal', function (event) {
        //   var button = $(event.relatedTarget) // Button that triggered the modal
        //   var recipient = button.data('whatever') // Extract info from data-* attributes
          
        //   var modal = $(this)
        //   modal.find('.modal-title').text(res.data.error.message)
         
        // })
      }
      resolve(res.data.error)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    ''
  )
  })
 
}
export const changeAdminPassword = function({ dispatch, state, commit, rootState }, payload) {
  var zetParallelleRequest = {
    action: "WISAServerConfig",
    method: "ChangeAdminPassword",
    data: [],
    type: "rpc",
    tid: 2
  };
  zetParallelleRequest.data = payload;

  // Herwerken naar EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS
  return new Promise((resolve, reject) => {
  restService.POST(
    "RPC/Router",
    zetParallelleRequest,
    function(res) {
      if(res.data.error ===null || res.data.error ===undefined ){
        // $("#passwordChangedSuccesfully").modal("show")
      }
      if(res.data.error !==null && res.data.error !==undefined){
        commit(globalMutationTypes.SHOW_MESSAGE, ["Fout: " + res.data.error.message, "error"], {
          root: true
        });
      
            }
      resolve(res.data.error)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    ''
  )
  })
 
}
export const changeServerIniFile = function({ dispatch, state, commit, rootState }, payload) {
  var zetParallelleRequest = {
    action: "WISAServerConfig",
    method: "SetServerConfig",
    data: [],
    type: "rpc",
    tid: 2
  };

  
  zetParallelleRequest.data = payload;

  // Herwerken naar EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS
  return new Promise((resolve, reject) => {
  restService.POST(
    "RPC/Router",
    zetParallelleRequest,
    function(res) {
      if(res.data.error ===null || res.data.error ===undefined ){
        // $("#passwordChangedSuccesfully").modal("show")
      }
      if(res.data.error !==null && res.data.error !==undefined){
        commit(globalMutationTypes.SHOW_MESSAGE, ["Fout: " + res.data.error.message, "error"], {
          root: true
        });
      
       
      }
      resolve(res.data.error)
    },
    function(res) {
    },
    undefined,
    true,
    ''
  )
  })
 
}
export const GetServerIniFile = function({ dispatch, state, commit, rootState }, payload) {
  var zetParallelleRequest = {
    action: "WISAServerConfig",
    method: "GetServerConfig",
    data: null,
    type: "rpc",
    tid: 1
  };


  // Herwerken naar EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS
  return new Promise((resolve, reject) => {
  restService.POST(
    "RPC/Router",
    zetParallelleRequest,
    function(res) {
      if(res.data.error ===null || res.data.error ===undefined ){
        // $("#passwordChangedSuccesfully").modal("show")
      }
      if(res.data.error !==null && res.data.error !==undefined){
        commit(globalMutationTypes.SHOW_MESSAGE, ["Fout: " + res.data.error.message, "error"], {
          root: true
        });
      
       
      }
      resolve(res)
    },
    function(res) {
    },
    undefined,
    true,
    ''
  )
  })
 
}

// *********************************** Configuratie **************************************************//


export const externSysteem = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {
  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "ExternSysteem/",
        method: "GET",
        api: "REST",
        parameters: {}
      }
    ],
    function(res) {
      console.log("SUCCES ExternSysteem ");
      resolve(res)
      // commit(mutationTypes.SET_EXTERNSYSTEEM_INFO, res[0].data.data);
    },
    function(res) {
      // reject()
    },
    false,
    0
  );

})
}
export const logFileInfo = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {
  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "LogFileInfo/",
        method: "GET",
        api: "REST",
        parameters: {
          'Location':payload
        }
      }
    ],
    function(res) {
      console.log("SUCCES LogFileInfo ");
      resolve(res)
      // commit(mutationTypes.SET_EXTERNSYSTEEM_INFO, res[0].data.data);
    },
    function(res) {
      // reject()
    },
    false,
    0
  );

})
}
export const getGemeente = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "Gemeente/",
        method: "GET",
        api: "REST",
      }
    ],
    function(res) {
  
  //  commit(mutationTypes.SET_BETALINGEN, res[0].data.data);
   resolve(res[0].data.data)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    0
  );
});
};
// export const downloadLogFileInfo = function({ dispatch, state, commit, rootState }, payload) {
//   return new Promise((resolve, reject) => {
//   restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
//     [
//       {
//         resource: "",
//         method: "GET",
//         externalServer: rootState.userInfo.loggedInConnectionObject.serverLocation+ '/bin/filemanager.cgi/Files/Logs/'+payload.Path+'?attachment=true',
//         // parameters: {
//         //   'attachment':true
//         // }
//       }
//     ],
//     function(res) {
//       console.log("SUCCES LogFileInfo ");
//       resolve(res)
//       // commit(mutationTypes.SET_EXTERNSYSTEEM_INFO, res[0].data.data);
//     },
//     function(res) {
//       // reject()
//     },
//     false,
//     0
//   );

// })
// }
export const putExternSysteem = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {
  restService.PUT(
      "ExternSysteem/"+payload.ID,
    {
      
      "ClientID":payload.ClientID,
      "ClientSecret":payload.ClientSecret,
      "ID":payload.ID
    },
    function(res) {
      console.log(res)

        resolve(res)
   
     
    },
    function(res) {
      
    
    },
    true,
    0
  );
  });
};
//https://testvwo.schoolware.be/webvwo/bin/server.fcgi/REST/WebsiteModule/
//?_dc=1578408539789&page=1&start=0&limit=0


export const websiteModule = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {
  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "WebsiteModule/",
        method: "GET",
        api: "REST",
        parameters: {}
      }
    ],
    function(res) {
      console.log("SUCCES WebsiteModule ");
      resolve(res)
      // commit(mutationTypes.SET_EXTERNSYSTEEM_INFO, res[0].data.data);
    },
    function(res) {
      // reject()
    },
    false,
    0
  );

})
}
export const getCursistInfo = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "vwocursist/"+payload[0],
        method: "GET",
        api: "REST"
      }
    ],
    function(res) {
  
   commit(mutationTypes.SET_CURSIST_INFO, res[0].data.data);
   resolve(res[0].data.data)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    0
  );
});
};
export const getCursistInfoPersonalia = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "vwocursistpersonalia/"+payload[0],
        method: "GET",
        api: "REST"
      }
    ],
    function(res) {
  
  //  commit(mutationTypes.SET_CURSIST_INFO, res[0].data.data);
   resolve(res[0].data.data)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    0
  );
});
};
export const getCursistInfoPersonaliaExtra = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "vwocursistpersonaliaextra/"+payload[0],
        method: "GET",
        api: "REST"
      }
    ],
    function(res) {
  
  //  commit(mutationTypes.SET_CURSIST_INFO, res[0].data.data);
   resolve(res[0].data.data)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    0
  );
});
};
export const getLeerling = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "leerling/",
        method: "GET",
        api: "REST"
      }
    ],
    function(res) {
  
   commit(mutationTypes.GET_LEERLING_GENERAL, res[0].data.data);
   resolve(res[0].data.data)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    0
  );
});
};
export const setLeerlingPersonalia = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {
    
  restService.PUT(
    "vwocursistpersonalia/" +payload[0],
    payload[1]
   ,
    function(res) {
      console.log(res)

        resolve(res)
    },
    function(res) {
      reject(res)
      // self.successMessage()
    },
    true,
    0
  );
  });
};
export const setLeerlingPersonaliaExtra = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {
    
  restService.PUT(
    "vwocursistpersonaliaextra/" +payload[0],
    payload[1]
   ,
    function(res) {
      console.log(res)

        resolve(res)
    },
    function(res) {
      reject(res)
      // self.successMessage()
    },
    true,
    0
  );
  });
};

// *********************************** Opleiding **************************************************//
export const getOpleiding = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "opleiding/",
        method: "GET",
        api: "REST",
        parameters: {
          LLID:btoa(payload)
        }
      }
    ],
    function(res) {
  
   commit(mutationTypes.SET_OPLEIDING_LIST, res[0].data.data);
   resolve(res[0].data.data)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    0
  );
});
};
export const getModules = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "gevolgdemodule/",
        method: "GET",
        api: "REST"
      }
    ],
    function(res) {
  
   commit(mutationTypes.SET_MODULE_LIST, res[0].data.data);
   resolve(res[0].data.data)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    0
  );
});
};
export const getParticipation = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "vwoparticipaties/",
        method: "GET",
        api: "REST",
        parameters: {
          LLID:btoa(payload)
        }
      }
    ],
    function(res) {
  
   commit(mutationTypes.SET_PARTICIPATION_LIST, res[0].data.data);
   resolve(res[0].data.data)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    0
  );
});
};
export const getGevolgdeopleiding = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "vwogevolgdeopleiding/",
        method: "GET",
        api: "REST",
        parameters: {
          LLID:btoa(payload)
        }
      }
    ],
    function(res) {
  
   commit(mutationTypes.SET_GEVOLGDEOPLEIDING_LIST, res[0].data.data);
   resolve(res[0].data.data)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    0
  );
});
};
// *********************************** Betalingen **************************************************//
export const getBetalingen = function({ dispatch, state, commit, rootState }, payload) {
  return new Promise((resolve, reject) => {

  restService.EXECUTE_CONCURRENT_WITH_CUSTOM_METHODS(
    [
      {
        resource: "betalingen/",
        method: "GET",
        api: "REST",
        parameters: {
          LLID:btoa(payload)
        }
      }
    ],
    function(res) {
  
   commit(mutationTypes.SET_BETALINGEN, res[0].data.data);
   resolve(res[0].data.data)
    },
    function(res) {
      reject()
    },
    undefined,
    false,
    0
  );
});
};